import { useHistory } from "react-router-dom";
import * as Styles from "./Option.styles";
import { useEffect, useState } from "react";
import { message, Select } from "antd";
import { FaChevronDown } from "react-icons/fa6";
import Check from "assets/images/health-analyse/check.svg";
import { InsuranceSection } from "../Start/Start";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { CHALLENGE, CLOSE, OPTION } from "routes/routes";
import ApiCollections from "configs/services/apiCollections";

function Option() {
  const [selectedPlan, setSelectedPlan] = useState("pro");
  const [insuranceOptions, setInsuranceOptions] = useState([]);
  const [selectedInsurance, setSelectedInsurance] = useState(null);
  const [refundAmount, setRefundAmount] = useState("0");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to track dropdown
  const history = useHistory();

  useEffect(() => {
    ApiCollections.getAllcoachingNutritionCourse()
      .then((res) => {
        // Assuming the response data has insurance providers
        if (res.getAllRefunds) {
          // Transform data into options format for Select component
          const options = res.getAllRefunds.map((item) => ({
            value: item.id,
            label: item.krankenkasse,
            refund: item.refund_amount,
          }));
          setInsuranceOptions(options);
        }
      })
      .catch((e) => console.log(e));
  }, []); // Added empty dependency array to run only once

  // Effect to disable/enable body scroll based on dropdown state
  useEffect(() => {
    if (isDropdownOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    // Cleanup function to ensure scroll is re-enabled on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isDropdownOpen]);

  const handleInsuranceChange = (value, option) => {
    setSelectedInsurance(value);
    // Format refund amount with comma as decimal separator and 2 decimal places
    // const formattedAmount = option.refund.toFixed(2).replace(".", ",");
    const finalValue = (150 / 100) * option.refund;
    setRefundAmount(finalValue);
  };

  const handleDropdownVisibleChange = (open) => {
    setIsDropdownOpen(open); // Update state when dropdown opens/closes
  };

  const handleBtnClick = () => {
    if (refundAmount === "0") {
      return message.error("Bitte wähle eine Krankenkasse aus.");
    }

    // Determine full price based on selected plan (for conversion tracking)
    const fullPrice = selectedPlan === "pro" ? 450 : 150;

    // Add selected plan, refund amount, and full price as query parameters
    history.push(
      `${CHALLENGE}?user=${selectedPlan}&refund=${encodeURIComponent(
        refundAmount.toLocaleString("de-DE")
      )}&fullPrice=${fullPrice}`
    );
  };

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Auswertung"}
          subHeadline={" Wir erreichen gemeinsam dein Ziel!"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        {/* Mobile view */}
        <Styles.MobileContent>
          <Styles.ContentSection>
            <Styles.InsuranceSection>
              <div className="check-text">Rückerstattung prüfen</div>
              <div className="insurance-dropdown">
                <h3 className="insurance-label">Krankenkasse</h3>
                <Select
                  placeholder="Bitte auswählen"
                  style={{ width: "100%" }}
                  options={insuranceOptions}
                  onChange={handleInsuranceChange}
                  suffixIcon={<FaChevronDown />}
                  onDropdownVisibleChange={handleDropdownVisibleChange} // Add this prop
                />
              </div>
              <div className="reimbursement-amount">
                <span>werden zurückerstattet</span>
                <span className="amount">
                  {refundAmount.toLocaleString("de-DE")} €
                </span>
              </div>
            </Styles.InsuranceSection>

            <Styles.PlanOptions>
              <Styles.PlanCard
                onClick={() => setSelectedPlan("pro")}
                selected={selectedPlan === "pro"}
              >
                <h3 className="plan-title">Foodiary Coaching PRO</h3>
                <h3 className="plan-price highlight">
                  Effektiv{" "}
                  {refundAmount == "0"
                    ? "100"
                    : ((450 - refundAmount) / 3)
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                  € pro Monat
                </h3>
                <div className="plan-duration">3 Monate Laufzeit</div>
                <Styles.Divider />
                <div className="plan-features">
                  <div className="feature">
                    <img src={Check} alt="check" />
                    <p>
                      <strong>3 Monate</strong> Smarte Ernährungsplaner App
                    </p>
                  </div>
                  <div className="feature">
                    <img src={Check} alt="check" />
                    <p>
                      <strong>3 Monate</strong> persönliche Ernährungsberatung
                    </p>
                  </div>
                  <div className="feature">
                    <img src={Check} alt="check" />
                    <p>
                      <strong>3 Monate</strong> Digitale Academy mit Online Kurs
                    </p>
                  </div>
                </div>
              </Styles.PlanCard>
              <Styles.PlanCard
                onClick={() => setSelectedPlan("plus")}
                selected={selectedPlan === "plus"}
              >
                <h3 className="plan-title">Coaching PLUS</h3>
                <h3 className="plan-price" style={{ color: "#142C1F" }}>
                  Effektiv ab{" "}
                  {refundAmount == "0"
                    ? "50"
                    : ((150 - refundAmount) / 3)
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                  € pro Monat
                </h3>
                <div className="plan-duration">3 Monate Laufzeit</div>
                <Styles.Divider />

                <div className="plan-features">
                  <div className="feature">
                    <img src={Check} alt="check" />
                    <p>
                      <strong>3 Monate</strong> digitale Unterstützung mit
                      Ernährungsplan, App und Lernacademy
                    </p>
                  </div>
                </div>
              </Styles.PlanCard>
            </Styles.PlanOptions>
            <InsuranceSection notTitle />
          </Styles.ContentSection>
        </Styles.MobileContent>

        {/* Desktop view - matching the image */}
        <Styles.DesktopContent>
          <Styles.DesktopHeader>
            <Styles.DesktopTitle>
              Wie darf ich dich unterstützen?
            </Styles.DesktopTitle>
            <Styles.DesktopSubtitle>
              <strong>3 Monate</strong> persönliche Unterstützung beim Aufbau
              deiner gesunden Gewohnheiten.
            </Styles.DesktopSubtitle>
          </Styles.DesktopHeader>

          <Styles.DesktopInsuranceSection>
            <Styles.InsuranceLabel>Krankenkasse</Styles.InsuranceLabel>
            <Styles.InsuranceSelectWrapper>
              <Select
                placeholder="Bitte auswählen"
                style={{ width: "100%" }}
                options={insuranceOptions}
                onChange={handleInsuranceChange}
                className="insurance-input"
                suffixIcon={<FaChevronDown />}
                onDropdownVisibleChange={handleDropdownVisibleChange} // Add this prop
              />
            </Styles.InsuranceSelectWrapper>
            <Styles.ReimbursementLine>
              <Styles.ReimbursementText>
                werden zurückerstattet
              </Styles.ReimbursementText>
              <Styles.ReimbursementAmount>
                {refundAmount.toLocaleString("de-DE")} €
              </Styles.ReimbursementAmount>
            </Styles.ReimbursementLine>
          </Styles.DesktopInsuranceSection>

          <Styles.DesktopFeeLabel>Beratungsgebühr:</Styles.DesktopFeeLabel>

          <Styles.DesktopPlansWrapper>
            <Styles.DesktopPlanCard
              active={selectedPlan === "pro"}
              onClick={() => setSelectedPlan("pro")}
            >
              <Styles.PlanHeader>
                <Styles.PlanName>Foodiary Coaching PRO</Styles.PlanName>
                <Styles.PlanPricing>
                  <Styles.PlanPrice active={selectedPlan === "pro"}>
                    Effektiv{" "}
                    {refundAmount == "0"
                      ? "100"
                      : ((450 - refundAmount) / 3)
                          .toFixed(2)
                          .replace(".", ",")}{" "}
                    € pro Monat
                  </Styles.PlanPrice>
                  <Styles.PlanDuration>3 Monate Laufzeit</Styles.PlanDuration>
                </Styles.PlanPricing>
                <Styles.Divider />
              </Styles.PlanHeader>
              <Styles.PlanFeatures>
                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>
                    <strong>3 Monate</strong> Smarte Ernährungsplaner App
                  </Styles.FeatureText>
                </Styles.Feature>
                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>
                    <strong>3 Monate</strong> persönliche Ernährungsberatung
                  </Styles.FeatureText>
                </Styles.Feature>
                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>
                    bis zu <strong>150€</strong> Kostenrückerstattung
                  </Styles.FeatureText>
                </Styles.Feature>
                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>
                    Wöchentliche Gruppencalls und persönliche Betreuung
                  </Styles.FeatureText>
                </Styles.Feature>
                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>
                    Ebooks, Lernvideos, Bibliothek uvm.
                  </Styles.FeatureText>
                </Styles.Feature>
              </Styles.PlanFeatures>
            </Styles.DesktopPlanCard>

            <Styles.DesktopPlanCard
              active={selectedPlan === "plus"}
              onClick={() => setSelectedPlan("plus")}
            >
              <Styles.PlanHeader>
                <Styles.PlanName>Foodiary Coaching PLUS</Styles.PlanName>
                <Styles.PlanPricing>
                  <Styles.PlanPrice>
                    Effektiv ab{" "}
                    {refundAmount == "0"
                      ? "50"
                      : ((150 - refundAmount) / 3)
                          .toFixed(2)
                          .replace(".", ",")}{" "}
                    € pro Monat
                  </Styles.PlanPrice>
                  <Styles.PlanDuration>3 Monate Laufzeit</Styles.PlanDuration>
                </Styles.PlanPricing>
              </Styles.PlanHeader>
              <Styles.Divider />

              <Styles.PlanFeaturesSecondCard>
                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>
                    <strong>3 Monate</strong> Smarte Ernährungsplaner App
                  </Styles.FeatureText>
                </Styles.Feature>

                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>Digitale Academy</Styles.FeatureText>
                </Styles.Feature>
                <Styles.Feature>
                  <Styles.FeatureCheck />
                  <Styles.FeatureText>
                    bis zu <strong>100%</strong> Kostenrückerstattung
                  </Styles.FeatureText>
                </Styles.Feature>
              </Styles.PlanFeaturesSecondCard>
            </Styles.DesktopPlanCard>
          </Styles.DesktopPlansWrapper>
        </Styles.DesktopContent>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
      >
        Weiter
      </button>
    </Styles.Container>
  );
}

export default Option;
